import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import GuidaItaobuySpreadsheet from "../pages/articoli/guida-itaobuy-spreadsheet/page";
import SicurezzaItaobuySpreadsheet from "../pages/articoli/sicurezza-itaobuy-spreadsheet/page";
import ProdottiMiglioriItaobuy from "../pages/articoli/prodotti-migliori-itaobuy/page";
import GuidaAcquistiItaobuy from "../pages/articoli/guida-acquisti-itaobuy/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/articoli/guida-itaobuy-spreadsheet",
    element: <GuidaItaobuySpreadsheet />,
  },
  {
    path: "/articoli/sicurezza-itaobuy-spreadsheet",
    element: <SicurezzaItaobuySpreadsheet />,
  },
  {
    path: "/articoli/prodotti-migliori-itaobuy",
    element: <ProdottiMiglioriItaobuy />,
  },
  {
    path: "/articoli/guida-acquisti-itaobuy",
    element: <GuidaAcquistiItaobuy />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;